module.exports = __webpack_public_path__ + "static/media/homeBanner.54c39a42.svg";